export const useStoreStreams = defineStore('StoreStreams', {
    state: () => ({
        streams: null,
        error: null,
        filter: {
            fields: {
                stream_ends: {
                    min: new Date(),
                },
            },
        },
    }),
    actions: {
        async getStreams() {
            this.error = null;
            ({streams: this.streams, error: this.error} = await useQueryStreams().get(this.filter));
        },
    },
    getters: {
        activeStreams() {
            return this.filterStreams({status: 'active'});
        },
        upcomingStreams() {
            return this.filterStreams({status: 'upcoming'});
        },
        filterStreams() {
            return ({status, limitTo}) => {
                if (!this.streams) return null;
                let streams = this.streams.filter((stream) => status === undefined || stream.stream_status === status);
                return limitTo ? streams.slice(0, limitTo) : streams;
            };
        },
        getStream() {
            return (streamSlug) => {
                if (!this.streams) return null;
                return this.streams.find((item) => item.stream_slug === streamSlug) || null;
            };
        },
    },
});
